import React from 'react';
import './SolarCalculator.css';

const SolarCalculator = ({ formData, handleInputChange }) => {
  const toggleLoad = (load) => {
    handleInputChange({
      target: {
        name: 'selectedLoads',
        value: formData.selectedLoads.includes(load)
          ? formData.selectedLoads.filter((item) => item !== load)
          : [...formData.selectedLoads, load],
      },
    });
  };

  return (
    <div className="form-group">
      <label>Gewünschte Last (Wähle alles, was du damit betreiben möchtest)</label>
      <div className="button-grid">
        <button
          type="button"
          className={formData.selectedLoads.includes('Haushaltsgeräte') ? 'selected' : ''}
          onClick={() => toggleLoad('Haushaltsgeräte')}
        >
          <i className="fas fa-blender"></i> Haushaltsgeräte
        </button>
        <button
          type="button"
          className={formData.selectedLoads.includes('Wallbox') ? 'selected' : ''}
          onClick={() => toggleLoad('Wallbox')}
        >
          <i className="fas fa-charging-station"></i> Wallbox
        </button>
        <button
          type="button"
          className={formData.selectedLoads.includes('Heizung') ? 'selected' : ''}
          onClick={() => toggleLoad('Heizung')}
        >
          <i className="fas fa-fire-alt"></i> Heizung
        </button>
        <button
          type="button"
          className={formData.selectedLoads.includes('Klimaanlage') ? 'selected' : ''}
          onClick={() => toggleLoad('Klimaanlage')}
        >
          <i className="fas fa-wind"></i> Klimaanlage
        </button>
        <button
          type="button"
          className={formData.selectedLoads.includes('Warmwasser') ? 'selected' : ''}
          onClick={() => toggleLoad('Warmwasser')}
        >
          <i className="fas fa-tint"></i> Warmwasser
        </button>
        <button
          type="button"
          className={formData.selectedLoads.includes('Beleuchtung') ? 'selected' : ''}
          onClick={() => toggleLoad('Beleuchtung')}
        >
          <i className="fas fa-lightbulb"></i> Beleuchtung
        </button>
      </div>
    </div>
  );
};

export default SolarCalculator;
